module.exports = __webpack_public_path__ + "static/media/background_header.5d7056d9.png";